import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import { fetchHealthTrackingData } from "../../redux/prospect-reducers/prospectSlice";
import HealthTrackingList from "../../components/fitness-profile/health-tracking/HealthTrackingList";
import ModalHeader from "../../components/ModalHeader";
import SelectExportables from "../../components/common-components/SelectExportables";
import { fetchExportApiData } from "../../redux/reducers/commonApiSlice";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const healthTrackingExportableData = [
  "all",
  "user_name",
  "user_mobile",
  "user_email",
  "dob",
  "gender",
  "plan_status",
  "gym_id",
  "gym_name",
  "subscription_date_added",
  "subscription_start_date",
  "subscription_expire_date",
  "profiling_last_date",
  "profiling_weight",
  "profiling_bmi",
  "profiling_target_weight",
  "profiling_status",
  "profiling_overdue_days",
  "profiling_milestone",
  "bca_last_date",
  "bca_report",
  "bca_status",
  "bca_overdue_days",
  "bca_pending_count",
];

const HealthTracking = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { healthTrackingLoading } = useSelector((state) => state.prospects);
  const { exportData, exportLoading } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const initialClickValues = {
    isModOpen: false,
    name: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [csvData, setCsvData] = useState();

  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedFitnessProfileStatus: "",
    selectedBCAStatus: "",
    selectedMonth: "",
    selectedYear: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    profiling_status: allFilters.selectedFitnessProfileStatus?.value || "",
    bca_status: allFilters.selectedBCAStatus?.value || "",
    dob_month: allFilters.selectedMonth?.value || "",
    dob_year: allFilters.selectedYear?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
    setCsvData();
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const getHealthTrackingData = (filters) => {
    dispatch(
      fetchHealthTrackingData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  function getExportedData(filters) {
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: "/user/health-tracking",
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExport = (filters) => {
    if (filters.is_export) {
      getExportedData(filters);
    } else {
      toast.error("IS Export Not Found!");
    }
  };

  useEffect(() => {
    getHealthTrackingData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      profiling_status: allFilters.selectedFitnessProfileStatus?.value || "",
      bca_status: allFilters.selectedBCAStatus?.value || "",
      dob_month: allFilters.selectedMonth?.value || "",
      dob_year: allFilters.selectedYear?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedFitnessProfileStatus,
    allFilters.selectedBCAStatus,
    allFilters.selectedMonth,
    allFilters.selectedYear,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    }
  }, [exportData]);

  return (
    <HelmetWrapper title="WTF: Health Tracking">
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeader
            title={
              clickValues.name === "exportModal"
                ? "Select Fields To Export"
                : clickValues.name?.replace(/_/g, "")
            }
            onClick={onCloseModal}
          />

          {clickValues.name === "exportModal" ? (
            <div>
              <SelectExportables
                name="health_tracking"
                exportableData={healthTrackingExportableData}
                filters={filters}
                callFunction={onClickExport}
                isLoadingCSV={exportLoading}
                csvData={csvData}
                setCsvData={setCsvData}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading="Member Health Tracking"
              isReload={() => getHealthTrackingData(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="health-tracking"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={healthTrackingLoading}
              searchPlaceHolder="Search by member name, mobile, email..."
              onClickExportBtn={() =>
                setClickValues({
                  isModOpen: true,
                  name: "exportModal",
                })
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <HealthTrackingList
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default HealthTracking;
